'use strict';

function CompanyListTitleFilter() {
  return stateName => {
    if(stateName === 'company_edit') { return '設定を変更する顧客を選択'; }
    if(stateName === 'device_type_select') { return '端末を新規に作成する顧客を選択'; }
    if(stateName === 'device_index') { return '設定変更する端末を持つ顧客を選択'; }
    if(stateName === 'demand_control_index') { return 'デマンド制御を行う顧客を選択'; }
    if(stateName === 'sa_reboot') { return '設顧客を選択'; }
    if(stateName === 'notify_list_show') { return '通知先を設定する顧客を選択'; }
    if(stateName === 'external_api_credential') { return 'API認証情報を確認する顧客を選択'; }
  }
}

export default angular.module('leptonApp.companyListTitle', [])
  .filter('companyListTitle', [CompanyListTitleFilter])
  .name;



// WEBPACK FOOTER //
// ./public/dev/components/filter/company-list-title-filter/company-list-title.filter.js